import React from "react";
import Marquee from "react-fast-marquee";
import testimonial1 from "../img/testimonial-1.jpg";
import testimonial2 from "../img/testimonial-2.jpg";
import testimonial3 from "../img/testimonial-3.jpg";
import testimonial4 from "../img/testimonial-4.jpg";
import { useLocation } from "react-router-dom";

const testimonials = [
  {
    img: testimonial1,
    text: `JDTS has had not only a huge impact on my business, but also a big impact in my life.
           Everything started to take off when I started to work with JDTS.
           These genius guys took us from $2000 to close to $800000 per month in January 2020!`,
    name: "Florian F.",
    role: "CEO, Ketorecipe",
  },
  {
    img: testimonial2,
    text: `What I appreciate most at JDTS are the results. 
           We started in October and the results exceed our expectations!`,
    name: "Alan",
    role: "CEO, Brilliant Pad",
  },
  {
    img: testimonial3,
    text: `I love the fact that my account manager at JDTS treats my account like their own. 
           JDTS has a high consideration for me and really cares about my business. 
           I love the consistency in my results and I have seen growth.`,
    name: "Wayne",
    role: "Founder, Trinity Hills",
  },
  {
    img: testimonial4,
    text: `I spent $3K on a video shoot and we got it back the first day we started running ads from those creatives.`,
    name: "Dave",
    role: "CEO, Paw.com",
  },
];

const Testimonial = () => {
  const location = useLocation();

  return (
    <div className="mb-5">
      <div
        id="testimonial"
        className="container-fluid position-relative opacity-0"
        style={{ top: "3rem", height: "10px" }}
      ></div>

      {location.pathname !== "/login" && (
        <div>
          <div
            className="container-fluid testimonial pt-5"
            style={{ overflow: "hidden" }}
          >
            <div className="container">
              <div
                className="mx-auto text-center mb-5"
                style={{ maxWidth: "900px" }}
              >
                <h5 className="section-title px-3">Testimonial</h5>
                <h1 className="mb-0">Our Clients Say!!!</h1>
              </div>
            </div>
          </div>

          <Marquee pauseOnHover gradient={false}>
            <div className="d-flex flex-nowrap gap-4 px-3">
              {testimonials.map((t, i) => (
                <div
                  key={i}
                  className="testimonial-item text-center rounded p-4 bg-light"
                   style={{
                      flex: "0 0 300px", // fixed card width
                      }}
                >
                  <div className="testimonial-comment mb-4"
                    style={{
                      minHeight: "130px", // equal height
                    }}
                  >
                    <p className="text-center testimonial-content">
                      {t.text}
                    </p>
                  </div>
                  <div className="testimonial-img p-1">
                    <img
                      src={t.img}
                      className="img-fluid rounded-circle"
                      alt={t.name}
                      style={{ width: "80px", height: "80px", objectFit: "cover", border:'3px dotted blue' }}
                    />
                  </div>
                  <div style={{ marginTop: "10px" }}>
                    <h5 className="mb-0">{t.name}</h5>
                    <p className="mb-0">{t.role}</p>
                    <div className="d-flex justify-content-center">
                      {Array.from({ length: 5 }).map((_, starIndex) => (
                        <i
                          key={starIndex}
                          className="fas fa-star text-primary"
                        ></i>
                      ))}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </Marquee>
        </div>
      )}
    </div>
  );
};

export default Testimonial;
